import * as React from "react"
import {Grid, Skeleton} from "@mui/material";
import {generateArrayByNumber} from "@ui-seeker/utils";


export default function PricingChangesWidgetSkeleton() {

	return <Grid container spacing={3}>
		{generateArrayByNumber(2).map(idx => <Grid item xs={6} key={idx}>
			<Skeleton variant="rectangular" height={150} />
		</Grid>)}
	</Grid>
}